// extracted by mini-css-extract-plugin
export default {"title":"BusinessSettingsClientForm_title__H8ZPC"};